var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center vh-100 login-background"},[_c('img',{staticClass:"spinner shadow rounded-circle",attrs:{"src":require("../../assets/images/spinner_purple_64x64.gif")}})])
}]

export { render, staticRenderFns }